// extracted by mini-css-extract-plugin
export var chip = "_ht-0";
export var filterDropdown = "_ht-5";
export var filterItem = "_ht-6";
export var icon = "_ht-1";
export var removeButton = "_ht-3";
export var removeIcon = "_ht-4";
export var separator = "_ht-2";